export default __webpack_public_path__ + "images/1f90309f5e16f2d6a3e5046d4017225a-finance_small.webp";